/* eslint-disable jsx-a11y/iframe-has-title */
import React from 'react';

import { Modal } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import { ContainerPdf, DanfeModal } from './styles';

import { AiOutlineDownload, AiOutlinePrinter } from 'react-icons/ai';
import { toast } from 'react-toastify';
import { LinearProgress } from '@material-ui/core';
import saveAs from 'file-saver';
import { useValidadorXML } from '~/pages/ValidadorXML/ValidadorContext';
import { LeitorPDF } from '../LeitorPDF';

export const ModalPDF: React.FC = () => {
  const { pdf, loadingPDF, isOpenModal, setIsOpenModal, dadosDaCapa } =
    useValidadorXML();
  const handleCloseModal = () => {
    return setIsOpenModal(false);
  };

  const handlePrinter = async () => {
    try {
      const byteArray = new Uint8Array(pdf.data);
      const blob = new Blob([byteArray], { type: 'application/pdf' });

      const fileURL = URL.createObjectURL(blob);
      const pdfWindow = window.open();
      if (pdfWindow) {
        pdfWindow.location.href = fileURL;
      }
    } catch (error) {
      return toast.error((error as Error).message);
    }
  };

  const handleGeneratePDF = async () => {
    try {
      const byteArray = new Uint8Array(pdf.data);
      const blob = new Blob([byteArray], { type: 'application/pdf' });

      saveAs(blob, `DANFE-${dadosDaCapa.chave_nfe}`);
    } catch (e) {
      return toast.error((e as Error).message);
    }
  };

  return (
    <>
      <DanfeModal
        show={isOpenModal}
        onHide={handleCloseModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        // size="xl"
        dialogClassName="custom-modal"
      >
        <Modal.Header>
          <Modal.Title>DANFE</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ContainerPdf>
            <div style={{ height: '5px' }}>
              {loadingPDF && (
                <LinearProgress
                  style={{
                    background: '#c2a0f8',
                    color: '#8850BF',
                  }}
                />
              )}
            </div>
            <LeitorPDF />
          </ContainerPdf>
        </Modal.Body>
        <Modal.Footer>
          <div className="actions">
            <div className="left">
              <Button
                className="btn-impressao"
                onClick={handlePrinter}
                title="Imprimir"
              >
                Imprimir
                <AiOutlinePrinter size={24} className="btn-icon" />
              </Button>
              <Button onClick={handleGeneratePDF} title="download">
                Download
                <AiOutlineDownload size={24} className="btn-icon" />
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </DanfeModal>
    </>
  );
};
